import { Star } from 'lucide-react';

import { Button } from '@/shadcn/button';
import { cn } from '@/shadcn/lib/utils';
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger
} from '@/shadcn/tooltip';

type Props = {
  isFavorite?: boolean;
  onChange: (value: boolean) => void;
  dataCy: string;
} & React.HTMLAttributes<HTMLButtonElement>;

export const AddToFavorite = ({
  isFavorite,
  onChange,
  className,
  dataCy
}: Props) => {
  const handleClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    e.preventDefault();
    onChange(!isFavorite);
  };

  const label = isFavorite ? 'Remove from favorites' : 'Add to favorites';

  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <Button
            aria-label={label}
            className={cn('group', className)}
            data-cy={dataCy}
            data-state={isFavorite ? 'active' : 'inactive'}
            onClick={handleClick}
            size="icon"
            variant="ghost"
          >
            <Star
              className={cn(
                'text-foreground transition-colors',
                isFavorite &&
                  'fill-yellow-500 text-yellow-500 group-hover:fill-foreground group-hover:text-foreground'
              )}
              strokeWidth={2}
            />
          </Button>
        </TooltipTrigger>
        <TooltipContent>{label}</TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
};
